import React from 'react'
import "../../../_css/Reporting.css"
import CustomChart from './CustomChart';

const ActiveUserChart = ({ activeUsers }) => {

  return (
    <div className='box-con'>
      <div className='admin-header di-flex'>
        <div className='heading-subtext'>Active users per month</div>
        {/* <DropDown options={periodData} data={performancePeriod} setData={setPerformancePeriod} /> */}


      </div>


      {activeUsers && <div className='admin-content' style={{ width: "100%", height: "300px", backgroundColor: "white" }}>

        <CustomChart
          type="bar"
          xData={[...Object.keys(activeUsers)]}
          yData={[...Object.values(activeUsers)]}
          label="Active Users"
          color="#23B4C3"
          tension={0}
          ygrid={true}
          yTicks={false}
          isMaxValue={true}
          barGap={0.6}
          perfixbar=""
          showValuesOnBar={true}
        />

      </div>}

    </div>
  )
}

export default ActiveUserChart